import { Component, Input } from '@angular/core';
import { Szme037aResponseCdtmnySyosaiRefInfDto } from 'sg-api';
import { BillDispZyuusyoPipe } from '../../../../../sg-kd-shared/pipes/bill-disp-zyuusyo.pipe';

/**
 * 契約情報
 * @export
 * @class UrikakekinElectricContractComponent
 */

@Component({
  selector: 'app-urikakekin-electric-contract',
  templateUrl: './urikakekin-electric-contract.component.html',
  styleUrls: ['./urikakekin-electric-contract.component.scss'],
  providers: [ BillDispZyuusyoPipe ]
})
export class UrikakekinElectricContractComponent {
  @Input() urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;

  constructor() { }

}
